import { render, staticRenderFns } from "./footer-contacts.vue?vue&type=template&id=6be57fe0&scoped=true&"
import script from "./footer-contacts.vue?vue&type=script&lang=js&"
export * from "./footer-contacts.vue?vue&type=script&lang=js&"
import style0 from "./footer-contacts.vue?vue&type=style&index=0&id=6be57fe0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be57fe0",
  null
  
)

export default component.exports